export const apiName: string = 'passageiros';
export const passageirosRoute: string = 'passageiros';
export const passageirosStorage: string = 'passageiros';
export const passageirosModuleName: any = {plural: 'Passageiros', single: 'Passageiro'};

export const apiNamePassageirosDeslocamento: string = 'passageiros-deslocamentos';

export const passageirosQuery: any = {
    "where":{
        "ativo":true,
        "nome":{"regexp":"/REPLACEHERE/i"}
    },
    "order":"nome"
};


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/passageiros/shared/data.service.ts
 **/